import { useState, type FormEvent, type ReactNode } from "react";
import type { AccountPatch } from "../../types/account";
import { useServerAnswer } from "../../hooks/useServerAnswer";
import { RefusalSentence } from "./RefusalSentence";

interface IdentifyQuestionProps {
  onAnswer: (body: AccountPatch) => Promise<void>;
}

const QUESTION = "Which account is this?";

/** 5b: the unnamed account's card, asked only when `last6` is empty (PATCH `nickname`). */
export function IdentifyQuestion({ onAnswer }: IdentifyQuestionProps): ReactNode {
  const [value, setValue] = useState("");
  const { busy, refusal, run, clear } = useServerAnswer(onAnswer);

  function handleSubmit(event: FormEvent): void {
    event.preventDefault();
    void run({ nickname: value.trim() });
  }

  return (
    <form className="account-question" onSubmit={handleSubmit}>
      <label htmlFor="identify-answer">{QUESTION}</label>
      <input
        id="identify-answer"
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={busy}
        maxLength={64}
      />
      <button type="submit" disabled={busy || value.trim() === ""}>
        Save
      </button>
      <RefusalSentence refusal={refusal} onDismiss={clear} />
    </form>
  );
}
